<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton'] ">
    <update-user-info-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></update-user-info-form>
  </j-modal>
</template>

<script>

  import UpdateUserInfoForm from './UpdateUserInfoForm'
  export default {
    name: 'UpdateUserInfoModal',
    components: {
      UpdateUserInfoForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
            return this.$store.getters.language
          }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        //this.$refs.realForm.submitForm();
        this.$refs.realForm.handleSubmit();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      show(){
          this.visible = true;
      },
    }
  }
</script>